export function asId(value) {
  return String(value ?? '').trim()
}

export function asNullableText(value) {
  const text = String(value ?? '').trim()
  return text || null
}

export function asBoolean(value) {
  return value === true || value === 'true' || value === 1 || value === '1'
}

export function mapLocation(raw) {
  if (!raw || typeof raw !== 'object') {
    return null
  }
  const lat = Number(raw.lat)
  const lng = Number(raw.lng)
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    return null
  }
  return { lat, lng }
}

export function mapLinks(raw) {
  const links = raw && typeof raw === 'object' ? raw : {}
  return {
    telegramId: asNullableText(links.telegram_id),
    telegramUsername: asNullableText(links.telegram_username),
    sendpulseId: asNullableText(links.sendpulse_id),
    whatsappId: asNullableText(links.whatsapp_id),
  }
}
